/*
  CRAN. — Scroll reveal (Partie 2 §6)
  Fondu + translation Y de 12-16px au scroll, avec un état de repos qui
  reste TOUJOURS visible tant que ce script n'a pas confirmé pouvoir
  gérer la révélation lui-même — voir le bug du hero "fantôme" corrigé
  précédemment : on ne cache jamais du contenu sans garantir qu'un
  observateur actif le révélera.

  .cran-reveal-ready n'est ajouté à <html> qu'ici, une fois
  l'IntersectionObserver prêt à observer — c'est cette classe, et elle
  seule, qui autorise cran-scroll-reveal.css à masquer l'état de repart
  des éléments [data-reveal]. Sans JS, ou avec prefers-reduced-motion,
  cette classe n'est jamais ajoutée : tout reste visible par défaut.
*/
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }
  if (!('IntersectionObserver' in window)) {
    return;
  }

  var elements = document.querySelectorAll('[data-reveal]');
  if (!elements.length) {
    return;
  }

  document.documentElement.classList.add('cran-reveal-ready');

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
  );

  elements.forEach(function (el, index) {
    var group = el.closest('[data-reveal-group]');
    var indexInGroup = index;
    if (group) {
      indexInGroup = Array.prototype.indexOf.call(
        group.querySelectorAll('[data-reveal]'),
        el
      );
    }
    el.style.transitionDelay = (indexInGroup % 6) * 70 + 'ms';
    observer.observe(el);
  });
})();
